import { Menu } from 'antd';
import React from 'react';
import { Export } from '../index';

const ExportMenuItem = (callback, context, trackEvent) => (
  <Menu.Item key="export">
    <Export
      context={context}
      clickCallback={callback}
      showIcon={false}
      trackEvent={trackEvent}
    />
  </Menu.Item>
);

export default ExportMenuItem;
